module.exports = __webpack_public_path__ + "img/tienda-7.2d8c3e3c.png";